import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button, InputGroup, Form, Spinner, Tabs, Tab, Table } from "react-bootstrap";
import clientAxios from '../../clients/clientAxios';
import { notify } from "react-notify-toast";
import { useHistory } from "react-router-dom";
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";
import moment from "moment";
import LoadingScreen from "../../Layout/LoadingScreen";
import ExcelDownload from "./ExcelDownload";

export default function StudentsCounter() {
  const history = useHistory(),
    [isLoading, setIsLoading] = useState(true),
    [isLoadingGraph, setIsLoadingGraph] = useState(true),
    [isLoadingYears, setIsLoadingYears] = useState(true),
    [data, setData] = useState([]),
    [show, setShow] = useState(false),
    [month, setMonth] = useState(""),
    [year, setYear] = useState(moment().format("YYYY")),
    [years, setYears] = useState([]),
    [since, setSince] = useState(moment().startOf("year").format("YYYY-MM-DD")),
    [to, setTo] = useState(moment().endOf("year").format("YYYY-MM-DD")),
    [display, setDisplay] = useState("anual"),
    [activeTab, setActiveTab] = useState('chart'),
    [availableYears, setAvailableYears] = useState([]),
    [year1, setYear1] = useState(moment().year() - 1),
    [year2, setYear2] = useState(moment().year()),
    [comparisonData, setComparisonData] = useState(null),
    [comparisonLoading, setComparisonLoading] = useState(false);
  const [comparisonTotals, setComparisonTotals] = useState(null);
  let counter = 0;
  useEffect(() => {
    if (counter === 0) {
      fetchData();
      ++counter;
      quantityOfYearsF();
    }
    // eslint-disable-next-line
  }, []);
  let dataGlobal = [];
  let months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Sept.",
    "Oct.",
    "Nov.",
    "Dic.",
  ];

  let fetchData = () => {
    clientAxios.post(`/students/studentChangeTracking`, {
      year,
      month,
      display,
      since,
      to
    }, {
      headers: { "auth-token": localStorage.getItem("JWT") || " " },
    })
      .then(({ data }) => {

        if (display === "anual") {
          for (let i = 0; i < 12; i++) {
            let counter = {
              up: 0,
              down: 0,
              commision: 0,
            },
              values = [],
              studentsChanges = [],
              classroom = data.data[i].filter((o) => o.type === "classroom"),
              active = data.data[i].filter((o) => o.type === "isActive");
            values.push(classroom, active);

            for (let indA = 0; indA < values[1].length; indA++) {
              if (Array.isArray(values[1][indA])) {
                values[1][indA].forEach((i) => {
                  if (i.to === "down") {
                    counter.down++;
                  } else if (i.to === "up") {
                    counter.up++;
                  } else if (i.to === "commissionChanged") {
                    counter.commision++;
                    studentsChanges.push(i);
                  }
                });
              } else {
                if (values[1][indA].to === "down") counter.down++;
                else if (values[1][indA].to === "up") counter.up++;
                else if (values[1][indA].to === "commissionChanged") {
                  counter.commision++;
                  studentsChanges.push(values[1][indA]);
                }
              }
            }

            let dataInside = {
              name: months[i],
              Activos: counter.up,
              Bajas: counter.down,
              Cambios: counter.commision,
            };
            dataGlobal.push(dataInside);
          }
        } else if (display === "specific") {
          for (let i = 0; i < 1; i++) {
            let counter = {
              up: 0,
              down: 0,
              commision: 0,
            },
              values = [],
              studentsChanges = [],
              classroom = data.data.filter((o) => o.type === "classroom"),
              active = data.data.filter((o) => o.type === "isActive");

            values.push(classroom, active);

            for (let indA = 0; indA < values[1].length; indA++) {
              if (Array.isArray(values[1][indA])) {
                values[1][indA].forEach((i) => {
                  if (i.to === "down") counter.down++;
                  else if (i.to === "up") counter.up++;
                  else if (i.to === "commissionChanged") {
                    counter.commision++;
                    studentsChanges.push(i);
                  }
                });
              } else {
                if (values[1][indA].to === "down") {
                  counter.down++;
                } else if (values[1][indA].to === "up") {
                  counter.up++;
                } else if (values[1][indA].to === "commissionChanged") {
                  counter.commision++;
                  studentsChanges.push(values[1][indA]);
                }
              }
            }

            let dataInside = {
              name: `${since} - ${to}`,
              Activos: counter.up,
              Bajas: counter.down,
              Cambios: counter.commision,
            };
            dataGlobal.push(dataInside);
          }
        } else if (display === "sixMonths") {
          let months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Sept.",
            "Oct.",
            "Nov.",
            "Dic.",
          ];
          for (let i = 0; i < 6; i++) {

            let counter = {
              up: 0,
              down: 0,
              commision: 0,
            };
            let values = [];
            let studentsChanges = [];
            var classroom = data.data[i].result.filter((o) => o.type === "classroom");
            var active = data.data[i].result.filter((o) => o.type === "isActive");

            values.push(classroom, active, data.data);

            for (let indA = 0; indA < values[1].length; indA++) {
              if (Array.isArray(values[1][indA])) {
                values[1][indA].forEach((i) => {
                  if (i.to === "down") counter.down++;
                  else if (i.to === "up") counter.up++;
                  else if (i.to === "commissionChanged") {
                    counter.commision++;
                    studentsChanges.push(i);
                  }
                });
              } else {
                if (values[1][indA].to === "down") {
                  counter.down++;
                } else if (values[1][indA].to === "up") {
                  counter.up++;
                } else if (values[1][indA].to === "commissionChanged") {
                  counter.commision++;
                  studentsChanges.push(values[1][indA]);
                }
              }
            }

            let dataInside = {
              name: months[data.data[i].month],
              Activos: counter.up,
              Bajas: counter.down,
              Cambios: counter.commision,
            };

            dataGlobal.push(dataInside);
          }
        }

        if (dataGlobal.length !== 0) {
          setData(dataGlobal);
          setIsLoading(false);
          setIsLoadingGraph(false)
        } else {
          setIsLoadingGraph(true)
          setIsLoading(true);
        }

      })
      .catch((err) => {
        notify.show(err.message, "error");
        history.push("/");
      });
  };

  const quantityOfYearsF = () => {
    var currentYear = parseInt(moment().format("YYYY"));
    var quantityOfYears = currentYear - 2020;
    let quantityOfYearsSelect = []
    for (let q = 0; q <= quantityOfYears; q++) {
      quantityOfYearsSelect.push(`${q < 10 ? "202" + q : "20" + (q + 20)}`)
    }
    setYears(quantityOfYearsSelect)
    setIsLoadingYears(false)
  }

  useEffect(() => {
    if (years.length > 0 && availableYears.length === 0) {
      fetchAvailableYears();
    }
    //eslint-disable-next-line
  }, [years]);
  useEffect(() => {
    setIsLoadingGraph(true);
    fetchData();
    //eslint-disable-next-line
  }, [year, month, display, since, to]);
  const clearSearch = () => {
    setSince(moment().startOf("year").format("YYYY-MM-DD"));
    setTo(moment().endOf("year").format("YYYY-MM-DD"));
    setYear(moment().format("YYYY"));
    setDisplay("anual");
  };

  const fetchAvailableYears = () => {
    setTimeout(() => {
      const yearsAsNumbers = years.map(y => parseInt(y));
      setAvailableYears(yearsAsNumbers);
      if (yearsAsNumbers.length >= 2) {
        setYear1(yearsAsNumbers[yearsAsNumbers.length - 2]);
        setYear2(yearsAsNumbers[yearsAsNumbers.length - 1]);
      }
    }, 100);
  };
  const fetchComparisonData = () => {
    if (year1 === year2) {
      notify.show('Debe seleccionar años diferentes', 'error');
      return;
    }
    setComparisonLoading(true);
    const payload = { year1, year2 };
    clientAxios.post('/graph/student-lifespan', payload, {
      headers: {
        'auth-token': localStorage.getItem('JWT')
      }
    })
      .then(({ data }) => {
        if (data.success && data.data && data.data.comparison) {
          setComparisonData(data.data.comparison);
          setComparisonTotals(data.data.totals);
        } else {
          setComparisonData([]);
          setComparisonTotals(null);
          notify.show('No se encontraron datos de comparación', 'warning');
        }
      })
      .catch((err) => {
        setComparisonData([]);
        setComparisonTotals(null);
        notify.show(err.response?.data?.message || 'Error al obtener comparativa', 'error');
      })
      .finally(() => {
        setComparisonLoading(false);
      });
  };

  const getTrendIndicator = (percentage) => {
    if (percentage > 0) {
      return <span style={{ color: '#28a745' }}>↑ {percentage.toFixed(1)}%</span>;
    } else if (percentage < 0) {
      return <span style={{ color: '#dc3545' }}>↓ {Math.abs(percentage).toFixed(1)}%</span>;
    }
    return <span style={{ color: '#6c757d' }}>= 0%</span>;
  };

  const renderStudentComparison = () => {
    return (
      <Container className="mb-5 pl-0 pr-0">
        <Container className="bg-light rounded shadow p-3 pl-0 mb-5">
          <h3 style={{ color: '#17a2b8', fontSize: '1.2rem' }}>Vida Útil de Alumnos</h3>
          <Form>
            <Row className="mb-2">
              <Col>
                <Form.Group className="my-auto">
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Año de Referencia</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as="select"
                      value={year1}
                      onChange={(e) => setYear1(parseInt(e.target.value))}
                    >
                      {availableYears.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </Form.Control>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="my-auto">
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Año a Comparar</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as="select"
                      value={year2}
                      onChange={(e) => setYear2(parseInt(e.target.value))}
                    >
                      {availableYears.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </Form.Control>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs="auto">
                <Button
                  variant="primary"
                  onClick={fetchComparisonData}
                  disabled={comparisonLoading}
                >
                  {comparisonLoading ? 'Cargando...' : 'Generar Reporte'}
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
        {comparisonLoading ? (
          <LoadingScreen />
        ) : comparisonData && comparisonData.length > 0 ? (
          <Row className="container d-flex bg-light rounded shadow p-3 ml-0 mr-0">
            <Col>
              <Table striped bordered hover size="sm" responsive>
                <thead className="thead-dark">
                  <tr>
                    <th>Periodo</th>
                    <th>Año {year1}</th>
                    <th>Año {year2}</th>
                    <th>% variación {year2}/{year1}</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonData.map((monthData, index) => (
                    <tr key={index}>
                      <td><strong>{monthData.monthName}</strong></td>
                      <td>{monthData.year1AverageLifespan.toFixed(2)}</td>
                      <td>{monthData.year2AverageLifespan.toFixed(2)}</td>
                      <td style={{
                        color: monthData.lifespanGrowthPercentage >= 0 ? '#28a745' : '#dc3545',
                        fontWeight: 'bold'
                      }}>
                        {monthData.lifespanGrowthPercentage >= 0 ? '+' : ''}{monthData.lifespanGrowthPercentage.toFixed(2)}%
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ fontWeight: 'bold', backgroundColor: '#e9ecef' }}>
                    <td><strong>Total Anual</strong></td>
                    <td>
                      {comparisonTotals ? comparisonTotals.year1TotalAverageLifespan.toFixed(2) : '0.00'}
                    </td>
                    <td>
                      {comparisonTotals ? comparisonTotals.year2TotalAverageLifespan.toFixed(2) : '0.00'}
                    </td>
                    <td style={{
                      color: comparisonTotals?.totalLifespanGrowth >= 0 ? '#28a745' : '#dc3545',
                      fontWeight: 'bold'
                    }}>
                      {comparisonTotals ?
                        (comparisonTotals.totalLifespanGrowth >= 0 ? '+' : '') +
                        comparisonTotals.totalLifespanGrowth.toFixed(2) + '%' : '0.00%'
                      }
                    </td>
                  </tr>
                </tfoot>
              </Table>
              <div className="mt-3 p-2 bg-light border rounded">
                <small className="text-muted">
                  <strong>Nota:</strong> El "Total Anual" representa el promedio de vida útil de todos los estudiantes
                  que se dieron de baja durante el año. Se calcula como el promedio de los promedios mensuales.
                </small>
              </div>
            </Col>
          </Row>
        ) : (
          <Row className="container d-flex bg-light rounded shadow p-3 align-items-center ml-0 mr-0">
            <Col className="d-flex justify-content-center text-muted">
              {comparisonData === null ?
                'Seleccione los años y haga clic en "Generar Reporte" para ver la vida útil de alumnos' :
                'No hay datos disponibles para los años seleccionados'
              }
            </Col>
          </Row>
        )}
      </Container>
    );
  };
  if (isLoading) {
    return <LoadingScreen />;
  } else if (isLoading === false) {
    return (
      <>
        <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
          <Tab eventKey="chart" title="Grafico de Altas y Bajas">
            <Container className="mb-5 pl-0 pr-0">
              <Container className="bg-light rounded shadow p-3 pl-0 mb-5">
                <Form>
                  <Row className="mb-2">
                    <Col>
                      <Form.Group className="my-auto">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Año</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            onChange={(e) => {
                              setYear(e.target.value);
                            }}
                            value={year}
                            name="year"
                            as="select"
                            className="w-75"
                            disabled={isLoadingYears || display === 'specific' || display === 'sixMonths'}
                          >
                            {isLoadingYears ? (<option>Cargando...</option>) : (
                              years.map((year) => <option value={year} key={year}>{year}</option>)
                            )
                            }
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="my-auto">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Diseño</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            onChange={(e) => {
                              setDisplay(e.target.value);
                            }}
                            value={display}
                            name="display"
                            as="select"
                            className="w-75"
                          >
                            <option value="anual">Anual</option>
                            <option value="sixMonths">6 meses</option>
                            <option value="specific">Específico</option>
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                      <Button className="mr-1 w-100" variant="success" onClick={() => setShow(true)}>
                        <i className="fas fa-dot-circle mr-2" />
                        Descargar excel
                      </Button>
                    </Col>
                  </Row>
                  <Row >
                    <Col>
                      <Form.Group className="my-auto">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Desde:</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            type="date"
                            value={since}
                            onChange={(e) => {
                              setSince(moment(e.target.value).format("YYYY-MM-DD"));
                            }}
                            name="Since"
                            className="w-100"
                            disabled={display === 'anual' || display === 'sixMonths'}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="my-auto">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Hasta:</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            type="date"
                            value={to}
                            onChange={(e) => {
                              setTo(moment(e.target.value).format("YYYY-MM-DD"));
                            }}
                            name="To"
                            className="w-100"
                            disabled={display === 'anual' || display === 'sixMonths'}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="my-auto">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Mes</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            onChange={(e) => {
                              setMonth(e.target.value);
                            }}
                            value={month}
                            name="month"
                            as="select"
                            className="w-75"
                            disabled={display === 'anual' || display === 'sixMonths'}
                          >
                            <option value="">Todos</option>
                            {months.map((monthMap) =>
                              <option value={monthMap} key={monthMap}>{monthMap}</option>
                            )}
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                      <Button className="w-100" onClick={() => clearSearch()}>Limpiar búsqueda</Button>
                    </Col>
                  </Row>

                  <ExcelDownload show={show} onHide={() => setShow(false)} />
                </Form>
              </Container>
              {isLoadingGraph ?
                <Row className="container d-flex bg-light rounded shadow p-3 align-items-center ml-0 mr-0">
                  <Col className="d-flex justify-content-center align-items-center">
                    <Spinner
                      animation="border"
                      role="status"
                      size="md"
                      className="ml-3 mr-3 my-auto"
                      variant="info"
                    />
                    <p className="m-0 p-0">Cargando...</p>
                  </Col>
                </Row>
                :
                <Row className="container d-flex bg-light rounded shadow p-3 align-items-center ml-0 mr-0">
                  <Col>
                    <BarChart
                      width={1000}
                      height={500}
                      data={data}
                      style={{ overflow: "visible" }}
                      className="mx-auto"
                      barSize={50}
                    >
                      <CartesianGrid strokeDasharray="1 1" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend className="mt-2" />
                      <Bar dataKey="Activos" fill="#78cb7d" />
                      <Bar dataKey="Bajas" fill="#E50000" />
                      <Bar dataKey="Cambios" fill="#0000FF" />
                    </BarChart>
                  </Col>
                </Row>
              }
            </Container>
          </Tab>
          <Tab eventKey="comparison" title="Reporte de vida util del alumno">
            {renderStudentComparison()}
          </Tab>
        </Tabs>
      </>
    );
  } else {
    return <div />;
  }
}
